import { StandardsModalFooter } from "./StandardsModalFooter";

export { StandardsModalFooter };
